import { Component, OnInit } from '@angular/core';

import { Location } from '@angular/common';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormGroup, FormBuilder, FormControl, NgForm } from '@angular/forms';

import axios from 'src/app/Service/axios';

import { Observable, map, of, startWith } from 'rxjs';

import { animate, state, style, transition, trigger } from '@angular/animations';

import { Router } from '@angular/router';

import * as XLSX from 'xlsx';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from './../../Service/other.service';

declare let $: any;

@Component({

  selector: 'app-trip-base-chart',

  templateUrl: './trip-base-chart.component.html',

  styleUrls: ['./trip-base-chart.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class TripBaseChartComponent implements OnInit {

  searchModel: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

  })

  list_BaseChart: any = [];

  list_Search: any = [];

  constructor(

    private location: Location,

    private Notification: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService:OtherService

  ) { }

  ngOnInit(): void {

  }

  async search_BaseChart() {

    this._otherService.Showspinner()

    let res = JSON.parse((await axios.post(`Peysepar_Report_TripBaseChart`, this.searchModel.value)).data.toString());

    this._otherService.nonespinner()

    this.list_BaseChart = res;

    this.list_Search = res;

    if (this.list_BaseChart.length == 0) return this.Notification.showError('موردی یافت نشد')

  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_BaseChart = this.list_Search.filter((el: any) => {

        return el.strRequestDate.includes(search) || el.strComment.includes(search)

      })

    }

    else if (search == '') this.list_BaseChart = this.list_Search;

  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'تعداد سفر به تفکیک جایگاه سازمانی.xlsx');

    }, 200);

  }

  goBack() {

    this.router.navigate(['/'])

  }

}
